import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Box, Button, Typography, useMediaQuery, Theme } from "@mui/material";
import { useNavigate } from "react-router";
import { MandatorContext } from "@rentablo/theming";
import { CashbackStepper } from "@features/cashbackWizard2.0/components/CashbackStepper/CashbackStepper";
import { Testimonials } from "@features/cashbackWizard2.0/components/Testimonials/Testimonials";
import { Logo } from "@rentablo/components";
import { useCashbackCode } from "@features/cashbackWizard2.0/hooks/useCashbackCode";
import { StepContainer } from "./components/StepContainer";

export const CashbackWizardStart = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { isOnvista } = useContext(MandatorContext);
  const isSm = useMediaQuery((theme: Theme) => theme.breakpoints.down("sm"));

  useCashbackCode();

  return (
    <Box data-testid="cashback-wizard-start">
      <Box display="flex" justifyContent="center" mb={isSm ? 14 : 30}>
        <Box pt={6}>
          <Logo variant="cashback" />
        </Box>
      </Box>
      <StepContainer maxWidth={994} isRateSupportShown={false}>
        <Typography
          variant={isOnvista ? "h1" : "h2"}
          component="h1"
          mb={isOnvista ? 0 : 5}
        >
          {t("cashbackWizard.start.title")}
        </Typography>
        <Typography
          variant={isOnvista ? "body1" : "subtitle2"}
          color="textSecondary"
          mb={11}
        >
          {t("cashbackWizard.start.subtitle")}
        </Typography>

        <CashbackStepper />

        <Box display="flex" justifyContent="center" mb={isSm ? 14 : 30}>
          <Button
            variant="primary"
            onClick={() => navigate("/cashback-wizard")}
            data-testid="start-now-button-top"
            sx={{ width: isSm ? "100%" : isOnvista ? "318px" : "530px" }}
          >
            {t("signupWizard.cashbackProcessIntroduction.startNow")}
          </Button>
        </Box>
        {!isOnvista && <Testimonials />}
      </StepContainer>
    </Box>
  );
};
